import { CurrencyLabel } from 'Modules/Currency';
import Space from 'Modules/Space';
import { bool, number, string } from 'prop-types';
import React from 'react';
import { Segment } from 'semantic-ui-react';
import { CURRENCY_SYMBOLS } from 'Constants/commons';

const PriceSummary = ({
  total,
  subTotal,
  loyaltyAmount,
  deliveryFee,
  discount,
  loading,
  practiceCost,
  currency,
}) => {
  const currencySymbol = CURRENCY_SYMBOLS[currency] || '';

  return (
    <Segment
      style={{
        background: '#F4F7FA',
        width: '100%',
        fontSize: 16,
        boxShadow: 'none',
        border: 'none',
      }}
      loading={loading}>
      <Space width="100%" gap={12}>
        <Space width="100%" justify="space-between" direction="horizontal">
          <span>Subtotal</span>
          <span>
            {currencySymbol} <CurrencyLabel value={subTotal} />
          </span>
        </Space>
        {practiceCost > 0 && (
          <Space width="100%" justify="space-between" direction="horizontal">
            <span>Practice Cost</span>
            <span>
              {currencySymbol} <CurrencyLabel value={practiceCost} />
            </span>
          </Space>
        )}
        {discount > 0 && (
          <Space width="100%" justify="space-between" direction="horizontal">
            <span>Coupon</span>
            <span>
              {currencySymbol} <CurrencyLabel value={-discount} />
            </span>
          </Space>
        )}
        {deliveryFee !== undefined && deliveryFee !== null && (
          <Space width="100%" justify="space-between" direction="horizontal">
            <span>Shipping fee</span>
            <span>
              {currencySymbol} <CurrencyLabel value={deliveryFee} />
            </span>
          </Space>
        )}

        {loyaltyAmount > 0 && (
          <Space width="100%" justify="space-between" direction="horizontal">
            <span>Used Points</span>
            <span>
              {currencySymbol} <CurrencyLabel value={-loyaltyAmount} />
            </span>
          </Space>
        )}
        <Space width="100%" justify="space-between" direction="horizontal">
          <strong>Total</strong>
          <strong>
            {currencySymbol} <CurrencyLabel value={total} />
          </strong>
        </Space>
      </Space>
    </Segment>
  );
};

export default PriceSummary;

PriceSummary.propTypes = {
  subTotal: number.isRequired,
  total: number.isRequired,
  loyaltyAmount: number,
  discount: number,
  deliveryFee: number,
  practiceCost: number,
  loading: bool,
  currency: string,
};
PriceSummary.defaultProps = {
  loyaltyAmount: 0,
  discount: 0,
  deliveryFee: 0,
  loading: false,
  currency: '',
};
